import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    // console.log("BodyController connected")
    document.addEventListener('body:refresh', this.refresh);
  }

  disconnect() {
    document.removeEventListener('body:refresh', this.refresh);
  }

  hideModal(event) {
    // event.preventDefault(); // this stops the delete from happening
    document.dispatchEvent(new Event('modal:hide'));
  }

  showModal(event) {
    document.dispatchEvent(new CustomEvent('modal:show', event));
  }

  loading(event) {
    document.body.classList.add('loading');
  }

  refresh(event) {
    // Turbo.renderStreamMessage("<turbo-stream action='refresh'></turbo-stream>")
    Turbo.visit(window.location, {action: 'replace'});
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

 }
